module.exports = __webpack_public_path__ + "img/color_cn.4a944b7.jpg";